__webpack_require__.p = "/shop2/";